import { useTranslation } from 'react-i18next';
import { RegistrySceneProp } from '../../../types';

interface ScenePropsTabProps {
  sceneProps: RegistrySceneProp[];
}

export default function ScenePropsTab({ sceneProps }: ScenePropsTabProps) {
  const { t } = useTranslation('scriptSummary');

  const sorted = [...sceneProps].sort(
    (a, b) => (b.appeared_in_episodes?.length ?? 0) - (a.appeared_in_episodes?.length ?? 0),
  );

  return (
    <div className="registry-card-grid">
      {sorted.map((sp, i) => (
        <div key={`${sp.name}-${i}`} className="registry-card">
          <div className="registry-card-header">
            <h4 className="registry-card-title">{sp.name}</h4>
            <span className={`registry-type-badge ${sp.type === 'scene' ? 'badge-scene' : 'badge-prop'}`}>
              {t(`sceneProps.${sp.type}`)}
            </span>
          </div>

          {sp.description && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('sceneProps.description')}</span>
              <p className="registry-field-text">{sp.description}</p>
            </div>
          )}

          {sp.tags?.length > 0 && (
            <div className="registry-tag-row">
              {sp.tags.map((tag) => (
                <span key={tag} className="registry-tag registry-tag-info">{tag}</span>
              ))}
            </div>
          )}

          {sp.appeared_in_episodes?.length > 0 && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('sceneProps.episodes')}</span>
              <div className="registry-episode-badges">
                {sp.appeared_in_episodes.slice(0, 10).map((ep) => (
                  <span key={ep} className="registry-ep-badge">{ep}</span>
                ))}
                {sp.appeared_in_episodes.length > 10 && (
                  <span className="registry-ep-badge registry-ep-overflow">+{sp.appeared_in_episodes.length - 10}</span>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
